// Boots Vault cart drawer, "The Clock" (2026-10-17). Defines <bv-dispatch-band>: the black band at the top of
// the cart drawer that counts down to the same-day dispatch cutoff and shows the delivery window for the
// visitor's country. A custom element so it re-initialises itself whenever Horizon morphs the drawer.
(function () {
  if (customElements.get('bv-dispatch-band')) return;
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function nowIn(zone) {
    try {
      var o = {}; new Intl.DateTimeFormat('en-US', { timeZone: zone, hour12: false, weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })
        .formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      return { wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(o.weekday), y: +o.year, mo: +o.month, d: +o.day, h: (+o.hour) % 24, m: +o.minute };
    } catch (e) { var n = new Date(); return { wd: n.getDay(), y: n.getFullYear(), mo: n.getMonth() + 1, d: n.getDate(), h: n.getHours(), m: n.getMinutes() }; }
  }
  function addDays(x, n) { var t = new Date(Date.UTC(x.y, x.mo - 1, x.d + n)); return { y: t.getUTCFullYear(), mo: t.getUTCMonth() + 1, d: t.getUTCDate(), wd: t.getUTCDay() }; }
  function addBiz(x, n) { var c = x, k = 0; while (k < n) { c = addDays(c, 1); if (c.wd !== 0 && c.wd !== 6) k++; } return c; }
  function short(x) { return DAYS[x.wd].slice(0, 3) + ' ' + x.d + ' ' + MONTHS[x.mo - 1]; }
  function left(mins) { var h = Math.floor(mins / 60), m = mins % 60; return h > 0 ? h + 'h ' + (m < 10 ? '0' : '') + m + 'm' : (m || 1) + 'm'; }

  class BvDispatchBand extends HTMLElement {
    connectedCallback() {
      this.render(); this._t = setInterval(this.render.bind(this), 30000);
      // Horizon morphs the drawer back to the server HTML after cart changes and on hydration;
      // when that rewrites our text, put the live text back.
      var self = this; this._mo = new MutationObserver(function () { var s = self.querySelector('[data-band-text]'); if (s && s.innerHTML !== self._last) self.render(); });
      this._mo.observe(this, { childList: true, subtree: true, characterData: true });
    }
    disconnectedCallback() { clearInterval(this._t); if (this._mo) this._mo.disconnect(); }
    render() {
      if (this.dataset.mode === 'id') return; // ID-only cart: the server text (made to order, 1-2 days) stands
      var ds = this.dataset, tz = ds.tz || 'Australia/Adelaide';
      var cut = (parseInt(ds.cutoffHour, 10) || 12) * 60 + (parseInt(ds.cutoffMinute, 10) || 0);
      var days = (ds.days || '1,2,3,4,5').split(',').map(Number);
      var n = nowIn(tz), mins = n.h * 60 + n.m;
      var demo = location.search.match(/[?&]dt_demo=(\d+)h(\d+)m/);
      if (demo) { n.wd = days[0]; mins = cut - (+demo[1] * 60 + +demo[2]); }
      var open = days.indexOf(n.wd) !== -1 && mins < cut, ship, lead;
      if (open) { ship = { y: n.y, mo: n.mo, d: n.d, wd: n.wd }; lead = 'Order in <b>' + left(cut - mins) + '</b>, ships today.'; }
      else {
        var off = 1; while (off < 8 && days.indexOf((n.wd + off) % 7) === -1) off++;
        ship = addDays(n, off); lead = 'Ships <b>' + (off === 1 ? 'tomorrow' : DAYS[ship.wd]) + '</b>.';
      }
      // transit days for the visitor's country, "AU:2-4;NZ:3-5;…;*:7-14"
      var cc = (ds.country || '').toUpperCase(), hit = null, star = null;
      (ds.transit || '').split(';').forEach(function (e) {
        var kv = e.split(':'); if (kv.length !== 2) return;
        var r = kv[1].split('-').map(Number), codes = kv[0].split(',').map(function (c) { return c.trim().toUpperCase(); });
        if (codes.indexOf('*') !== -1) star = r; if (cc && codes.indexOf(cc) !== -1) hit = r;
      });
      var t = hit || star, arr = '';
      if (t) { var a = addBiz(ship, t[0]), b = addBiz(ship, t[1] || t[0]); arr = ' Arrives ' + (a.mo === b.mo ? DAYS[a.wd].slice(0, 3) + ' ' + a.d : short(a)) + ' – ' + short(b) + '.'; }
      var text = this.querySelector('[data-band-text]'); this._last = lead + arr; if (text && text.innerHTML !== this._last) text.innerHTML = this._last;
      this.classList.toggle('is-open', open);
    }
  }
  customElements.define('bv-dispatch-band', BvDispatchBand);
})();

// BOOTSVAULTiD fold-out under the first pair (2026-10-18): when opened, bring the whole panel into view in the cart list
document.addEventListener('toggle', function (e) {
  var d = e.target; if (!d || !d.matches || !d.matches('.bv-idrow') || !d.open) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  setTimeout(function () { d.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); }, 30);
}, true);
